'use es6';

import { getDefaultNullValue, isOperatorIncludesObjectsWithNoValueSet } from '../../utilities/defaultNullValue';
import After from '../../filterQueryFormat/operator/After';
import DefaultNullValueRecord from '../../filterQueryFormat/DefaultNullValueRecord';
import FilterOperatorType from '../propTypes/FilterOperatorType';
import FormattedMessage from 'I18n/components/FormattedMessage';
import PropTypes from 'prop-types';
import { useCallback } from 'react';
import UICheckbox from 'UIComponents/input/UICheckbox';
import { REMOVE_DEFAULT_VALUE_LOGIC } from '../../permissions/gates';
import { jsx as _jsx } from "react/jsx-runtime";
function FilterOperatorIncludeObjectsWithNoValueSetInput(props) {
  const {
    onChange,
    value,
    filterFamily,
    getObjectPropertyLabel,
    isUngated
  } = props;
  const onCheckboxChange = useCallback(evt => {
    const isChecked = evt.target.checked;
    let defaultNullValue;
    if (isUngated(REMOVE_DEFAULT_VALUE_LOGIC)) {
      defaultNullValue = DefaultNullValueRecord({
        includeObjectsWithNoValueSet: isChecked
      });
    } else {
      defaultNullValue = isChecked ? getDefaultNullValue(value, true) : DefaultNullValueRecord();
    }
    onChange(defaultNullValue);
  }, [value, onChange, isUngated]);
  let unknownFieldLabel = value.field.label;
  if (value instanceof After) {
    unknownFieldLabel = getObjectPropertyLabel(filterFamily, value.value);
  }
  const isChecked = isOperatorIncludesObjectsWithNoValueSet(value);
  return /*#__PURE__*/_jsx(UICheckbox, {
    checked: isChecked,
    onChange: onCheckboxChange,
    size: "small",
    style: {
      minHeight: 'auto'
    },
    children: /*#__PURE__*/_jsx(FormattedMessage, {
      message: "customerDataFilters.FilterOperatorInput.includeObjectsWithNoValueSet",
      options: {
        label: unknownFieldLabel
      }
    })
  });
}

/* eslint-disable-next-line hubspot-dev/no-default-props-assignment */
FilterOperatorIncludeObjectsWithNoValueSetInput.defaultProps = {
  isUngated: () => false
};
FilterOperatorIncludeObjectsWithNoValueSetInput.propTypes = {
  filterFamily: PropTypes.string.isRequired,
  getObjectPropertyLabel: PropTypes.func.isRequired,
  isUngated: PropTypes.func,
  onChange: PropTypes.func.isRequired,
  value: FilterOperatorType.isRequired
};
export default FilterOperatorIncludeObjectsWithNoValueSetInput;